// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"b368cc7c","383":"d8984348"}[chunkId] + ".chunk.js";
};